import React from 'react';

export default props => {
    return (
        <svg viewBox="0 0 34 34" {...props}>
            <path fill="#FFF" fillRule="nonzero"
                  d="M21.201 19.218c.799.566 2.52 1.788 3.32 2.353a.88.88 0 0 1 .323 1.004c-.123.363-.384.824-.932 1.285-1.714 1.438-4.444 2.042-9.85-4.401s-4.337-9.027-2.624-10.465c.547-.46 1.046-.637 1.424-.694.389-.06.768.14.936.495l1.739 3.67a.881.881 0 0 1-.082.894l-.952 1.32a.875.875 0 0 0-.027.993c.343.528.923 1.38 1.555 2.133.631.753 1.37 1.472 1.831 1.902a.875.875 0 0 0 .982.145l1.466-.708c.289-.139.629-.113.891.074z"/>
        </svg>
    );
}